import * as React from 'react';
import * as styles from './styles.module.scss';

interface Props {
  handleClick: (event: any) => void;
}

const SearchIcon = ({ handleClick }: Props) => {
  return (
    <svg
      className={handleClick ? styles.searchIcon : ''}
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
      onClick={event => handleClick(event)}
    >
      <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Search" transform="translate(-32.000000, -7.000000)" fill="#4F4F4F">
          <path
            d="M47.804749,21.3907416 L43.456393,17.0420523 C44.2140636,15.9983802 44.6667326,14.7190402 44.6667326,13.3333663 C44.6667326,9.8410148 41.8257178,7 38.3333663,7 C34.8410148,7 32,9.8410148 32,13.3333663 C32,16.8257178 34.8410148,19.6667326 38.3333663,19.6667326 C39.7190402,19.6667326 40.9983802,19.2140636 42.0420523,18.456393 L46.3907416,22.804749 C46.6510763,23.0650837 47.0730785,23.0650837 47.3334132,22.804749 L47.804749,22.3337465 C48.0650837,22.0730785 48.0650837,21.6510763 47.804749,21.3907416 L47.804749,21.3907416 Z M34.0000104,13.3333663 C34.0000104,10.9440205 35.9440205,9.00001042 38.3333663,9.00001042 C40.7227121,9.00001042 42.6667222,10.9440205 42.6667222,13.3333663 C42.6667222,15.7227121 40.7227121,17.6667222 38.3333663,17.6667222 C35.9440205,17.6667222 34.0000104,15.7227121 34.0000104,13.3333663 L34.0000104,13.3333663 Z"
            id="search-icon"
          />
        </g>
      </g>
    </svg>
  );
};

export default SearchIcon;
